import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField, Typography } from '@mui/material';

import Iconify from '../../../../components/Iconify';
import { useAccomodationDiagram } from '../AccomodationDiagramContext';

export const OrderAccommodationPrefixDialog = props => {
  const { open, setOpen } = props;
  const { order, setOrder, setOrders, changedPrefixes, setChangedPrefixes } = useAccomodationDiagram();
  const [prefix, setPrefix] = React.useState(order.accommodation_prefix || '');

  const onSubmit = () => {
    const newOrder = { ...order };
    newOrder.accommodation_prefix = prefix;
    setOrder(newOrder);
    setOrders(prev => prev.map(item => item.id === newOrder.id ? newOrder : item));
    const newPrefixes = changedPrefixes;
    newPrefixes[order.identifier] = prefix;
    setChangedPrefixes(newPrefixes);
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
    >
      <DialogContent>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1} mt={2}>
          <Typography variant="subtitle2" flex="1 1 30%">Prefix</Typography>
          <TextField
            sx={{ flex: '1 1 80%' }}
            type="text"
            placeholder="prefix"
            value={prefix}
            onChange={e => setPrefix(e.target.value)}
            autoFocus
            multiline
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack>
          <Button
            fullWidth
            variant="contained"
            endIcon={<Iconify icon={'eva:save-fill'} />}
            onClick={onSubmit}
          >
            Zapisz zmiany
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};
